import React, { useEffect, useState } from "react";
import { ArrowDown } from "lucide-react";
import { BRAND, HERO_IMAGES } from "../mock/mock";
import { HERO_AUTO_ADVANCE_MS } from "../lib/constants";

const Hero = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(
      () => setIdx((i) => (i + 1) % HERO_IMAGES.length),
      HERO_AUTO_ADVANCE_MS
    );
    return () => clearInterval(t);
  }, []);

  return (
    <section className="relative h-[100svh] min-h-[640px] w-full overflow-hidden bg-black text-white">
      {/* Background slideshow — real AMS campaign photos */}
      <div className="absolute inset-0">
        {HERO_IMAGES.map((src, i) => (
          <div
            key={src}
            className={`absolute inset-0 transition-opacity duration-[1400ms] ease-out ${
              i === idx ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={src}
              alt="AMS outdoor advertising campaign"
              className="w-full h-full object-cover grayscale"
              loading={i === 0 ? "eager" : "lazy"}
            />
          </div>
        ))}
        {/* Dark overlay for legibility (large hero allows gradient) */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/45 to-black/90" />
        <div className="absolute inset-0 grain" />
      </div>

      {/* Top thin label */}
      <div className="absolute top-24 left-0 right-0 z-10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between text-[11px] uppercase tracking-[0.3em] text-white/70">
          <span>Pan-India · Out-of-Home</span>
          <span className="hidden md:inline">Est. — Adways Marketing Solutions</span>
        </div>
      </div>

      {/* Slide indicator */}
      <div className="absolute top-1/2 right-6 md:right-10 -translate-y-1/2 z-10 hidden md:flex flex-col items-center gap-3">
        {HERO_IMAGES.map((src, i) => (
          <button
            key={`dot-${src}`}
            onClick={() => setIdx(i)}
            aria-label={`Show campaign ${i + 1}`}
            className={`w-[2px] transition-all duration-300 ${
              i === idx ? "h-12 bg-white" : "h-6 bg-white/35 hover:bg-white/65"
            }`}
          />
        ))}
      </div>

      {/* Center copy */}
      <div className="relative z-10 h-full flex items-end">
        <div className="max-w-[1400px] mx-auto w-full px-6 md:px-10 pb-24 md:pb-28">
          <h1 className="font-display uppercase text-[14vw] md:text-[9vw] leading-[0.9] tracking-tight">
            We Build <br />
            <span className="font-serif-display italic font-black">brands</span>{" "}
            in the <br />
            real world
          </h1>

          <p className="mt-10 max-w-md text-white/85 text-sm md:text-base leading-relaxed">
            {BRAND.subTagline}
          </p>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/60">
        <span className="text-[10px] uppercase tracking-[0.32em]">Scroll</span>
        <ArrowDown className="w-4 h-4 animate-bounce" />
      </div>
    </section>
  );
};

export default Hero;
